import type { paths } from '@luxuryescapes/contract-svc-tag';

export const SELECT_ALL_VALUE = '__SELECT_ALL__';

type ContractTagType = paths['/api/tags/v1/tags']['post']['requestBody']['content']['application/json']['tagType'];

export const TAG_ASSIGNMENT_ENTITY_ID_MAX_LENGTH = 100;

export const TAG_TYPE_BASIC = 'basic';
export const TAG_TYPE_AWARENESS_BUNDLE = 'awareness_bundle';
export const TAG_TYPE_PASSPORT = 'passport';
export const TAG_TYPE_CONTENT_TAG = 'content_tag';

export const TAG_TYPE_OPTIONS = [
  {
    value: TAG_TYPE_BASIC,
    label: 'Basic',
    description: 'Assign experiences, hotels, and destinations without a schedule. Add hotels by offer ID.',
  },
  {
    value: TAG_TYPE_AWARENESS_BUNDLE,
    label: 'Awareness bundle',
    description:
      'Use for existing tags that label awareness bundle content across destinations, hotels, and experiences.',
  },
  {
    value: TAG_TYPE_PASSPORT,
    label: 'Passport',
    description: 'Use for Experiences Passport tags. Only voucher-based experiences can be assigned.',
  },
  {
    value: TAG_TYPE_CONTENT_TAG,
    label: 'Content Tag',
    description: 'Use for permanent Experience content tags without schedules.',
  },
] as const;

export type TagTypeValue = (typeof TAG_TYPE_OPTIONS)[number]['value'];

type Equal<Left, Right> = [Left] extends [Right] ? ([Right] extends [Left] ? true : never) : never;
const _tagTypesMatchContract: Equal<TagTypeValue, ContractTagType> = true;
void _tagTypesMatchContract;

export const isAwarenessBundleTag = (tagType: TagTypeValue): boolean => tagType === TAG_TYPE_AWARENESS_BUNDLE;

export const isBasicTag = (tagType: TagTypeValue): boolean => tagType === TAG_TYPE_BASIC;

export const isContentTag = (tagType: TagTypeValue): boolean => tagType === TAG_TYPE_CONTENT_TAG;

export const isPassportTag = (tagType: TagTypeValue): boolean => tagType === TAG_TYPE_PASSPORT;

export const allowsFreeformTagName = (tagType: TagTypeValue): boolean => isBasicTag(tagType);
